"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DateFormatter = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DateFormatter = function DateFormatter(_ref) {
  var children = _ref.children;

  if (typeof children === 'number' || typeof children === 'string') {
    var rawDate = (0, _momentTimezone.default)(children);
    var dateValue = rawDate.tz('America/New_York');
    return /*#__PURE__*/_react.default.createElement("span", null, dateValue.format('MMM D, YYYY'));
  }

  return children;
};

exports.DateFormatter = DateFormatter;
DateFormatter.propTypes = {
  children: _propTypes.default.any
};
var _default = DateFormatter;
exports.default = _default;